import React, { useEffect, useState } from 'react';
import ProductDropdown from './ProductDropdown';
import ActivityDropdown from './ActivityDropdown';
import RegionalCountryDropdown from './RegionalCountryDropdown';
import './DataSetSelector.scss';

const DataSetSelector = ({ selectedValues, onChange, restrictFilters = {} }) => {
  
  const [_selectedValues, setSelectedValues] = useState({
    products: [],
    activities: [],
    countries: [],
  });

  // Track if update is from prop or user
  const updateSource = React.useRef('prop');

  useEffect(() => {
    // Initialize selected values from props
    updateSource.current = 'prop';
    setSelectedValues(selectedValues);
  }, [selectedValues]);

  // Only call onChange if update was from user interaction
  useEffect(() => {
    if (updateSource.current === 'user') {
      onChange(_selectedValues);
      console.log('DataSetSelector - onChange called with:', _selectedValues);
    }
    // Reset source after effect
    updateSource.current = null;
  }, [_selectedValues]);

  // Helper to set values from user interaction
  const setValuesFromUser = (values) => {
    updateSource.current = 'user';
    setSelectedValues(values);
  };

  return (
    <div className="dataset-selector" style={{ width: '100%' }}>
      <div style={{ marginBottom: '12px' }}>
        <ProductDropdown
          selectedValues={_selectedValues.products}
          onChange={(products) => setValuesFromUser({ ..._selectedValues, products })}
          restrictProductGroups={restrictFilters.productGroups || null}
        />
      </div>
      <div style={{ marginBottom: '12px' }}>
        <ActivityDropdown
          selectedValues={_selectedValues.activities}
          onChange={(activities) => setValuesFromUser({ ..._selectedValues, activities })}
          restrictActivities={restrictFilters.activities || null}
        />
      </div>
      <div style={{ marginBottom: '12px' }}>
        <RegionalCountryDropdown
          selectedValues={_selectedValues.countries}
          onChange={(countries) => setValuesFromUser({ ..._selectedValues, countries })}
          restrictRegions={restrictFilters.regions || null}
          restrictCountries={restrictFilters.countries || null}
        />
      </div>
    </div>
  );
};

export default DataSetSelector;